module.exports = __webpack_public_path__ + "static/media/12a.5d930411.jpg";